import { Instagram, Sparkles } from "lucide-react";
import { BUSINESS } from "../data/content";
import { Reveal } from "./Reveal";
import { Section } from "./Section";

export const Events = () => (
  <Section id="events" eyebrow="Events" title="Evenings at Roma's">
    <Reveal>
      <div
        className="card-surface relative overflow-hidden p-8 md:p-12"
        data-testid="events-placeholder"
      >
        <div
          className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#d4af37]/10 blur-3xl"
          aria-hidden="true"
        />
        <div className="flex flex-col items-start gap-8 md:flex-row md:items-center md:justify-between">
          <div className="max-w-2xl">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-dashed border-[#d4af37]/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.25em] text-[#d4af37]">
              <Sparkles size={13} aria-hidden="true" /> Dates to be announced
            </div>
            <h3 className="font-display text-2xl font-semibold text-[#f7f4ef] md:text-3xl">
              Gatherings are in the works
            </h3>
            <p className="mt-4 text-base leading-relaxed text-[#b5afa7]">
              We're putting together a calendar of intimate evenings — music, readings and shared
              tables. Dates and details will be announced on Instagram first, so follow along and be
              the first to know.
            </p>
          </div>
          <a
            href={BUSINESS.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold shrink-0"
            data-testid="events-instagram-button"
          >
            <Instagram size={16} aria-hidden="true" /> Follow {BUSINESS.instagramHandle}
          </a>
        </div>
      </div>
    </Reveal>
  </Section>
);
